// extracted by mini-css-extract-plugin
module.exports =  {"root":"_2PyF5","title":"T5bLU"};